export const superAdminLayoutState = {
    footerText: ''
}

